import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'screen-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './screen-spinner.component.html',
  styleUrls: ['./screen-spinner.component.scss'],
})
export class ScreenSpinnerComponent {}
